<template>
    <div>
        <h4 class="text-slate-800 text-base font-medium mb-3">
            Redemption Type
        </h4>
        <div class="flex flex-wrap gap-4" v-if="redemptionStep === 1">
            <label
                class="w-full md:w-[31%] gap-2 relative rounded-lg border-2 flex flex-col justify-start p-4 hover:bg-gray-100 transition-colors cursor-pointer"
                :class="{
                    'border-orange-500 hover:border-orange-300':
                        redemptionType.id ===
                        activeRedemption.redemption_type_id,
                    'border-slate-200 hover:border-slate-400':
                        redemptionType.id !==
                        activeRedemption.redemption_type_id,
                }"
                v-for="redemptionType in redemptionTypes"
                :key="redemptionType.id"
            >
                <input
                    type="radio"
                    v-model="activeRedemption.redemption_type_id"
                    :value="redemptionType.id"
                    class="sr-only"
                />
                <div
                    class="w-10 h-10 p-2 bg-white rounded-full border border-slate-200 justify-center items-center"
                >
                    <Icon :icon="redemptionType.icon" class="text-slate-500" />
                </div>
                <h3 class="text-slate-800 text-base font-medium">
                    {{ redemptionType.name }}
                </h3>
            </label>
        </div>
    </div>
</template>
<script setup>
import { storeToRefs } from 'pinia';
import { useTripsStore } from '@/store/trips';
import Icon from '@/components/trips/icons.vue';
const tripsStore = useTripsStore();

const { activeRedemption, redemptionTypes, redemptionStep } =
    storeToRefs(tripsStore);
</script>
